import React from 'react'

// styles
import * as SC from './SkipLinkStyles'

type Props = {
	href: string
	children: React.ReactNode
}

const SkipLink = (props: Props) => {
	const { href, children } = props

	return <SC.SkipLink href={href}>{children}</SC.SkipLink>
}

export default SkipLink
